module start {

    export class Clickapp {

        static heart = '<svg class="heart" viewBox="0 0 32 29.6"><path d="M23.6,0c-3.4,0-6.3,2.7-7.6,5.6C14.7,2.7,11.8,0,8.4,0C3.8,0,0,3.8,0,8.4c0,9.4,9.5,11.9,16,21.2 c6.1-9.3,16-12.1,16-21.2C32,3.8,28.2,0,23.6,0z"/></svg>';


        static maxRings = 10;


        constructor() {



        }


        /**
         * Nur zum Nachladen der weiteren Ringbilder sofern vorhanden ...
         * @constructor
         */
        InitLoad(): any {

            window.localStorage.removeItem('shop');

         //   this.InitCollectClick()
            let divel = document.getElementById('ladealle');
            if (divel) {
                divel.onclick = (e: any) => {
                    e.preventDefault();
                    divel!.remove();
                    let imgcont = document.getElementById('ringbildcoll');
                    let x = document.createElement('div');
                    //@ts-ignore
                    x.innerHTML = Bilder;
                    imgcont!.appendChild(x);
                    // setTimeout(() => {
                    //     new start.Clickapp().InitCollectClick();
                    // }, 125)

                }
            }
        } //end InitLoad


        InitCollectClick(): any {
            /*let all = document.querySelectorAll('[data-shop]');
            if (all && all.length) {
                for (let e = 0; e < all.length; e++) {
                    (<HTMLDivElement>all[e]).onclick = start.Clickapp.CollectClickEvent;
                }
            }*/
        }//end InitCollectClick

        static CollectClickEvent(event: any): any {
            event.preventDefault();
            let $this = event.currentTarget;
            let which = $this.getAttribute('data-shop');
            ///erst entfernen falls vorhanden
            if ($this.classList.contains('imgb')) {
                $this!.classList.remove('imgb');
                $this!.querySelector('svg').remove();
                if (localStore.getItem('shop')) {
                    let st = JSON.parse(localStore.getItem('shop')!);
                    let index = st.indexOf(which);
                    if (index > -1) {
                        //@ts-ignore
                        st.splice(index, 1);
                    }
                    localStore.setItem('shop', JSON.stringify(st));
                }
            } else { //dann hinzufügen
                let all = document.querySelectorAll('.imgb');
                if (all.length === start.Clickapp.maxRings) {
                    window.alert('Sie können maximal ' + start.Clickapp.maxRings + ' Ringpaare auswählen');
                } else {
                    $this!.classList.add('imgb');
                    $this!.innerHTML += start.Clickapp.heart;

                    if (localStore.getItem('shop')) {
                        let st = JSON.parse(localStore.getItem('shop')!);
                        if (st.length < start.Clickapp.maxRings) {
                            let index = st.indexOf(which);
                            if (index < 0) {
                                //@ts-ignore
                                st.push(which);
                            }
                        }
                        localStore.setItem('shop', JSON.stringify(st));
                    } else {
                        let xt = [];
                        xt.push(which);
                        localStore.setItem('shop', JSON.stringify(xt));
                    }
                }
            }
        } //end CollectClickEvent


        static CollectImagesFromLocalstoreToForm(): void {


            let all = JSON.parse(localStore.getItem('shop')!);

            let st = '';

            if (all && all.length) {
                for (let e = 0; e < all.length; e++) {
                    st += '<picture class="max30">';
                    st += '<source srcset="/ressources/img/thumbs/' + all[e] + '.webp" type="image/webp">';
                    st += '<source srcset="/ressources/img/thumbs/' + all[e] + '.jpg" type="image/jpeg">';
                    st += '<img class="" src="/ressources/img/thumbs/' + all[e] + '.jpg" alt="Alt Text!">';
                    st += '</picture>';
                }
            }
            document.getElementById('insertImages')!.innerHTML = st;
        }


        static CollectFromImgNoToArtNo(): any {
            let all = JSON.parse(dataBack);


            let allRegistered = JSON.parse(localStore.getItem('shop')!);
            let ArtNr = [];
            for (let e = 0; e < allRegistered.length; e++) {
                let tmp = all.find((itm: any) => {
                    return itm.BildNr === parseInt(allRegistered[e], 0)
                });
                ArtNr.push(
                    {
                        Artikelnr: tmp.Art,
                        Link: "https://gerstner-trauringe.de/ressources/img/thumbs/" + (tmp.BildNr.toString()).padStart(8, '0') + ".jpg"
                    });
            }

            return ArtNr;
        }


    }   ///end Clickapp

}
